import React from 'react';

import styles from './SubscriptionDivider.module.scss';

const SubscriptionDivider = () => <hr className={styles.bns3_subscriptionDivider} />;

SubscriptionDivider.dispayName = 'SubscriptionDivider';

export default SubscriptionDivider;
